<script setup>
import { onMounted, ref } from 'vue';
import { create_ticket } from '@/services/tickets.js'
import { useRoute } from 'vue-router';
import { swalError, swalSuccess } from '@/helper';

const support = ref({
  topic: '',
  subject: '',
  description: ''
})

const route = useRoute()
onMounted(()=>{
  support.value.ticket_type = 'support_ticket'
  if (route.query.topic){
    support.value.topic = route.query.topic
    support.value.subject = route.query.subject
    support.value.ticket_type = 'assessment_help'
  }
})
async function submitForm(){
  let response = await create_ticket(support.value)
  if(response.error){
    swalError(response.result, true)
    return
  }
  swalSuccess('Support ticket has been send')
  support.value = {
    topic: '',
    subject: '',
    description: ''
  }
}
</script>

<template>
  <div id="contact_form" class="card">
    <div class="card-body">
      <form class="theme-form" @submit.prevent="submitForm()">
        <h4>Still need help</h4>
        <div class="form-group">
          <label class="col-form-label">Topic / Title</label>
          <input class="form-control" type="text" required="" placeholder="Something is wrong" v-model="support.topic"/>
        </div>
        <div class="form-group">
          <label class="col-form-label">Subject</label>
          <input class="form-control" type="text" required="" placeholder="Let us know how can help you" v-model="support.subject"/>
        </div>
        <div class="form-group">
          <label class="col-form-label">Your message</label>
          <textarea class="form-control" name="message" id="message" cols="30" rows="10" v-model="support.description"></textarea>
        </div>
        <div class="form-group mt-3">
          <button type="submit" class="btn btn-light-primary">
            Send message
          </button>
        </div>
      </form>
    </div>
  </div>
</template>